import { IMergeFile } from 'interfaces-lib';
import { ILocalMergeFile } from '../merge-component/merge-controller.service';

// TODO: this will want changing so there's a list of file checkers

export enum FileCheckReason {
  AlreadyExists,
}
export type LocalFileChecker = (fileToCheck: ILocalMergeFile, existingFiles: IMergeFile[]) => { ok: boolean; reason?: FileCheckReason };

export const AlreadyExistsLocalFileChecker: LocalFileChecker = (fileToCheck: ILocalMergeFile, existingFiles: IMergeFile[]) => {
  const alreadyExists = existingFiles.find((f) => f.name === fileToCheck.name) !== undefined;
  if (alreadyExists) {
    return { ok: false, reason: FileCheckReason.AlreadyExists };
  }

  return { ok: true };
};

export const OkLocalFileChecker: LocalFileChecker = (fileToCheck: ILocalMergeFile, existingFiles: IMergeFile[]) => ({ ok: true });
